import contactSchema from 'forms/contactSchema'
import { getPractioners } from "../selectors/employments";
import { findEntity } from "../selectors/entities";
import relationshipSchema from "./relationshipSchema";

const dossierSchema = function(state, props, showDossierNumber) {
  const showResponsibleSelector  = getPractioners(state).length > 1

  const dossier = findEntity(state, 'dossier', props.entityId)
  const relationshipCount = dossier
    ? dossier.relationships.toRefArray().filter((r) => r.deleted !== "1").length
    : 0
  return {
    "ui:order": ["patientId", "dossierNumber", "extraRemark" , 'responsibleIds' , "relationships", 'communicationRecipients', "healthFundId",  'locationId', '*'],
    "ui:readonly": props.readonly,
    "patientId": {
      "ui:field": "NestedFormField",
      "ui:options": {
        "entityName": "contact",
        "titleKey": "components.dossier_form.patient"
      },
      "ui:schema": contactSchema(state, props, true)
    },
    "extraRemark":{
      "ui:widget": "TextWidget"
    },
    "dossierNumber":{
      "ui:widget": showDossierNumber? "TextWidget" : "hidden",
      "ui:options": {
        width: 4
      }
    },
    "healthFundId": {
      "ui:field": "SelectorField",
      "ui:options": {
        width: 6,
        "entityName": "healthFund",
        "displayAttribute": (healthFund) => `${healthFund.name}`,
        "includeBlank": true,
      }
    },
    "responsibleIds": {
      "ui:widget" : showResponsibleSelector ? undefined : "hidden",
      "ui:field": "MultiSelectorField",
      "ui:options": {
        width: 6,
        "entityName": "employment",
        "displayAttribute": (employment) => `${employment.user?.firstName} ${employment.user?.lastName}`,
        "selector": getPractioners
      }
    },
    "locationId": {
      "ui:field": "SelectorField",
      "ui:options": {
        width: 6,
        "entityName": "location",
        "displayAttribute": (location) => `${location.name}`,
      }
    },
    "isArchived": {
      "ui:widget": "hidden",
    },
    "relationships": {
      "ui:field": "ArrayField",
      "ui:options": {
        "entityName": "relationship",
        "displayTitle": false
      },
      "items": {
        "ui:field": "NestedFormField",
        "ui:options": {
          "entityName": "relationship",
          "displayTitle": false,
          "inline": true
        },
        "ui:schema": (relationship) => relationshipSchema(state,props,relationship)
      }
    },
    "communicationRecipients": {
      "ui:field": "CommunicationRecipientsField",
      "ui:visible": relationshipCount >= 1,
      "items": {
        "ui:field": "NestedFormField",
        "ui:options": {
          "entityName": "communicationRecipient"
        }
      }
    }
  }
}

export default dossierSchema;
